import { useState, useEffect } from "react";
import { useTheme } from "../../../theme";

export default function ScrollToTop() {
  const t = useTheme();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll to top"
      style={{
        position: "fixed",
        bottom: 28,
        right: 28,
        zIndex: 80,
        width: 44,
        height: 44,
        borderRadius: 12,
        border: `1px solid ${t.borderStrong}`,
        background: t.navBg,
        backdropFilter: "blur(16px)",
        color: t.textMid,
        fontSize: 18,
        cursor: "pointer",
        transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
        opacity: show ? 1 : 0,
        transform: show ? "translateY(0)" : "translateY(20px)",
        pointerEvents: show ? "auto" : "none",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: `0 4px 20px ${t.shadow}`,
      }}
    >↑</button>
  );
}
